import React from 'react';
import { Home, FileText, LogOut, PieChart } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Sidebar() {
  const location = useLocation();
  const path = location.pathname;
  const { logout } = useAuth();

  const isActive = (route) => {
    if (route === '/') return path === '/';
    return path.startsWith(route);
  };

  return (
    <aside className="hidden md:flex w-64 bg-white border-r border-gray-200 h-full min-h-[calc(100vh-60px)] flex-col">
      <nav className="flex-1 py-4 overflow-y-auto">
        <ul className="space-y-1">
          <li>
            <Link to="/" className={`flex items-center gap-3 px-6 py-2 rounded-r-full mr-4 ${isActive('/') ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-100'}`}>
              <Home className="w-5 h-5" />
              <span className="font-medium">Dashboard</span>
            </Link>
          </li>
          <li>
            <Link to="/months" className={`flex items-center gap-3 px-6 py-2 rounded-r-full mr-4 ${isActive('/month') && !isActive('/reports') ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-100'}`}>
              <FileText className="w-5 h-5" />
              <span className="font-medium">All Months</span>
            </Link>
          </li>
          <li>
            <Link to="/reports" className={`flex items-center gap-3 px-6 py-2 rounded-r-full mr-4 ${isActive('/reports') ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-100'}`}>
              <PieChart className="w-5 h-5" />
              <span className="font-medium">Reports</span>
            </Link>
          </li>
          <li>
            <button onClick={logout} className="w-full flex items-center gap-3 px-6 py-2 text-gray-700 hover:bg-gray-100 rounded-r-full mr-4 text-left">
              <LogOut className="w-5 h-5" />
              <span className="font-medium">Logout</span>
            </button>
          </li>
        </ul>
      </nav>
    </aside>
  );
}
